import { Component } from "@angular/core";

@Component({
    selector: "app-not-found",
    standalone: true,
    imports: [],
    templateUrl: "./not-found.html",
    styleUrl: "./not-found.scss",
})
export class NotFound {}
